import { SearchFilter } from "../../../common/components/functional/FilterSearchField/FilterSearchField";
import { SALARY_TYPE_OPTIONS } from "../../../common/constants/SalaryTypes";
import { NameIdOption } from "../../../common/types/commonTypes";
import { SalaryIncreaseStatus } from "../types/common";
import { EmploymentSalary } from "../types/queries";

export const MOCK_SHIFT_SALARIES_API_RESPONSE = [
  {
    version: 3,
    talentId: "c9d22cd5-1757-46fc-abab-d6a26245416f",
    workTitleId: "wt001",
    afterRaiseSalaryPerDate: [
      {
        date: "2025-01-23",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-25",
        salary: {
          BASE_Tuntipalkka: "13",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-26",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "2",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
    ],
    hrRepresentative: "6b37c591-33d7-4dc0-a2eb-4d7726b3c3cf",
    firstName: "Marko",
    lastName: "Oikarinen",
    status: "IDLE" as SalaryIncreaseStatus,
  },
  {
    version: 1,
    talentId: "ed243bec-df97-4c41-9059-621a52cf9470",
    workTitleId: "wt001",
    afterRaiseSalaryPerDate: [
      {
        date: "2025-01-23",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-25",
        salary: {
          BASE_Tuntipalkka: "13",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-26",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "2",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
    ],
    hrRepresentative: "6b37c591-33d7-4dc0-a2eb-4d7726b3c3cf",
    firstName: "Ronny",
    lastName: "Friman",
    status: "IDLE" as SalaryIncreaseStatus,
  },
  {
    version: 1,
    talentId: "ed243bec-df97-4c41-9059-621a52cf9470",
    workTitleId: "wt003",
    afterRaiseSalaryPerDate: [
      {
        date: "2025-01-23",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-25",
        salary: {
          BASE_Tuntipalkka: "13",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-26",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "2",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
    ],
    hrRepresentative: "6b37c591-33d7-4dc0-a2eb-4d7726b3c3cf",
    firstName: "Ronny",
    lastName: "Friman",
    status: "IDLE" as SalaryIncreaseStatus,
  },
];

export const MOCK_EMPLOYMENT_SALARIES_API_RESPONSE: EmploymentSalary[] = [
  {
    version: 1,
    employmentId: "c9d22cd5-emp05",
    employerName: "Acme Corp",
    workTitleId: "wt001",
    raiseDateSalary: {
      date: "2025-01-23",
      salary: {
        BASE_Tuntipalkka: "12",
        "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
        Luvanhaltijanedustajanlisa: "1",
      },
    },
    afterRaiseSalaryPerDate: [
      {
        date: "2025-01-23",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-25",
        salary: {
          BASE_Tuntipalkka: "13",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-26",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "2",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
    ],
    hrRepresentative: "6b37c591-33d7-4dc0-a2eb-4d7726b3c3cf",
    firstName: "Marko",
    lastName: "Oikarinen",
    status: "IDLE" as SalaryIncreaseStatus,
    raiseDateContEmpExists: false,
    talentId: "c9d22cd5-1757-46fc-abab-d6a26245416f",
  },
  {
    version: 1,
    employmentId: "c9d22cd5-emp04",
    employerName: "Globex Inc",
    workTitleId: "wt002",
    raiseDateSalary: {
      date: "2025-01-23",
      salary: {
        BASE_Tuntipalkka: "12",
        "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
        Luvanhaltijanedustajanlisa: "1",
      },
    },
    afterRaiseSalaryPerDate: [
      {
        date: "2025-01-23",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-25",
        salary: {
          BASE_Tuntipalkka: "13",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "1",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
      {
        date: "2025-01-26",
        salary: {
          BASE_Tuntipalkka: "12",
          "Palkkaryhman_mukainen_palkka_(tiedoksi)": "2",
          Luvanhaltijanedustajanlisa: "1",
        },
      },
    ],
    hrRepresentative: "6b37c591-33d7-4dc0-a2eb-4d7726b3c3cf",
    firstName: "Marko",
    lastName: "Oikarinen",
    status: "IDLE" as SalaryIncreaseStatus,
    raiseDateContEmpExists: true,
    talentId: "ed243bec-df97-4c41-9059-621a52cf9470",
  },
];

export enum BULK_SALARY_INCREASE_FILTER_NAMES {
  TARGET = "target",
  IS_INCREASE_APPLIED = "isIncreaseApplied",
  HAS_CONT_EMP = "hasContEmp",
  BASE_EQUALS_GROUP = "baseEqualsGroup",
  SALARY_TYPE = "salaryType",
  WORK_TIME_TYPE = "workTimeType",
  TES = "tes",
  TES_SALARY_TABLE_ID = "tesSalaryTableId",
  TES_SELECTION_AT_OR_AFTER_RAISE = "tesSelectionAtOrAfterRaise",
  TES_SELECTION_MODES = "tesSelectionModes",
  SALARY_DATE_RANGE = "salaryDateRange",
  WORK_TITLES = "workTitles",
  SALARY_INCREASE_START_DATE = "salaryIncreaseStartDate",
  IS_UNCLEAR = "isUnclear",
}
// And for `TES_SALARY_TABLE_ID` filter we would need to have option "ALL" where it would consider valid tables under that tes_id whose validity ended day before raise date.
export const LABEL_WIDTH = 156;

/**
 * Source option when the bulk flow applies to salaries not yet selected from a TES salary table.
 * Preview and table-based UI are omitted for this value.
 */
export const BULK_SALARY_TES_TABLES_NON_TABLE_SOURCE_ID =
  "non-table-salaries" as const;
export const BULK_SALARY_TABLE_FILTER_ALL = "ALL" as const;

export enum BULK_SALARY_INCREASE_TARGETS {
  /**
   * KTA_SINGLE is to fetch just enough to figure out what ongoing kta calculations there are.
   */
  KTA_SINGLE = "KTA_SINGLE",
  /**
   * KTA is target to fetch all KTAs to be risen
   */
  KTA = "KTA",
  SHIFT_SALARIES = "SHIFT_SALARIES",
  EMPLOYMENT = "EMPLOYMENT",
  EMPLOYMENT_SHIFTS = "EMPLOYMENT_SHIFTS",
  /**
   * Bulk edits backed by TES salary table projections (table-to-table); row fetch not implemented yet.
   */
  TES_TABLES = "TES_TABLES",
}

/**
 * The page size for fetching shift salaries.
 * This is used to limit the number of shift salaries fetched in a single API call.
 * The default value is set to 500, which means that when fetching shift salaries,
 * the API will return a maximum of 500 shift salaries per request.
 * This helps to manage the amount of data transferred and processed at once,
 * ensuring better performance and responsiveness in the application.
 */
export const SHIFT_SALARY_PAGE_SIZE = 500;
export const MAX_TO_LOAD = 3000;
export const TARGET_OPTIONS: NameIdOption[] = [
  {
    id: BULK_SALARY_INCREASE_TARGETS.EMPLOYMENT_SHIFTS,
    name: "Työsuhde - lyhyet",
  },
  { id: BULK_SALARY_INCREASE_TARGETS.EMPLOYMENT, name: "Työsuhde - pitkät" },
  { id: BULK_SALARY_INCREASE_TARGETS.SHIFT_SALARIES, name: "Vuorojen palkat" },
  { id: BULK_SALARY_INCREASE_TARGETS.KTA, name: "Keskituntiansio" },
  {
    id: BULK_SALARY_INCREASE_TARGETS.TES_TABLES,
    name: "TES-palkkataulukot",
  },
];

export const IS_INCREASE_APPLIED_OPTIONS: NameIdOption[] = [
  { id: "false", name: "Ei" },
  { id: "true", name: "Kyllä" },
];

export const OPTION_DONT_CARE = "n/a";
export const HAS_CONT_EMP_OPTIONS: NameIdOption[] = [
  { id: "false", name: "Ei" },
  { id: "true", name: "Kyllä" },
  { id: OPTION_DONT_CARE, name: "Väliäkö hällä" },
];
export const INCLUDE_UNCLEAR_OPTIONS: NameIdOption[] = [
  { id: "false", name: "Ei" },
  { id: "true", name: "Kyllä" },
  { id: OPTION_DONT_CARE, name: "Väliäkö hällä" },
];

export const BASE_EQUALS_GROUP_OPTIONS: NameIdOption[] = [
  { id: "false", name: "Ei" },
  { id: "true", name: "Kyllä" },
  { id: OPTION_DONT_CARE, name: "Väliäkö hällä" },
];

export const WORKING_TIME_OPTIONS: NameIdOption[] = [
  { id: "PART_TIME", name: "Osa-aika" },
  { id: "VARIABLE_TIME", name: "Vaihtelevat" },
  { id: "FULL_TIME", name: "Kokoaika" },
];

export const TES_SELECTION_AT_OR_AFTER_RAISE_OPTIONS: NameIdOption[] = [
  { id: "true", name: "Kyllä" },
  { id: "false", name: "Ei" },
  { id: OPTION_DONT_CARE, name: "Väliäkö hällä" },
];

export const TES_SELECTION_MODE_OPTIONS: NameIdOption[] = [
  { id: "INFO_ONLY", name: "INFO_ONLY" },
  { id: "WITH_COMPS", name: "WITH_COMPS" },
  { id: "FULL_SALARY", name: "FULL_SALARY" },
  { id: "NO_MATCH", name: "NO_MATCH" },
];

export const BULK_SALARY_FILTER_OPTIONS = {
  [BULK_SALARY_INCREASE_FILTER_NAMES.TARGET]: TARGET_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_TYPE]: SALARY_TYPE_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.IS_INCREASE_APPLIED]:
    IS_INCREASE_APPLIED_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.HAS_CONT_EMP]: HAS_CONT_EMP_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.BASE_EQUALS_GROUP]:
    BASE_EQUALS_GROUP_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TIME_TYPE]: WORKING_TIME_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.IS_UNCLEAR]: INCLUDE_UNCLEAR_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_AT_OR_AFTER_RAISE]:
    TES_SELECTION_AT_OR_AFTER_RAISE_OPTIONS,
  [BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_MODES]:
    TES_SELECTION_MODE_OPTIONS,
};

export const BULK_SALARY_INCREASE_DEFAULT_FILTERS: SearchFilter[] = [
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.TARGET,
    value: "",
    displayName: "Haettava kohde",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.IS_INCREASE_APPLIED,
    value: "",
    displayName: "Korotus tehty",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.HAS_CONT_EMP,
    value: "",
    displayName: "Nippu voimassa",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.IS_UNCLEAR,
    value: "",
    displayName: "Epäselvä",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.BASE_EQUALS_GROUP,
    value: "",
    displayName: "Peruspalkka palkkaryhmän mukainen",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_TYPE,
    value: "",
    displayName: "Palkkausmuoto",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TIME_TYPE,
    value: [],
    displayName: "Työaikamuoto",
    displayValue: "",
    type: "text",
    tooltip: "Tämä valinta vain jos valittu KK-palkka", // Näkyy vain jos "KK-palkka" valittuna
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.TES,
    value: "",
    displayName: "Työehtosopimus",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.TES_SALARY_TABLE_ID,
    value: "",
    displayName: "TES-palkkataulukko",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_AT_OR_AFTER_RAISE,
    value: "",
    displayName: "Taulukkolinkki korotuspvm+",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_MODES,
    value: [],
    displayName: "Taulukkotilan moodi",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_DATE_RANGE,
    value: null,
    displayName: "Palkkausrivien aikaväli",
    displayValue: "",
    type: "dateRange",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TITLES,
    value: [],
    displayName: "Tehtävänimikkeet",
    displayValue: "",
    type: "text",
  },
  {
    name: BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_INCREASE_START_DATE,
    value: "",
    displayName: "Uusi palkkarivin pvm",
    displayValue: "",
    type: "text",
  },
];

export const boxStyles = {
  display: "flex",
  justifyContent: "space-between",
  bgcolor: "#fff",
  height: "56px",
  alignItems: "center",
  width: "100%",
  p: 2,
  pr: "14px",
  position: "relative",
  borderRadius: "4px",
  mb: "20px",
  boxShadow: "rgba(16, 24, 40, 0.1) 0px 4px 6px",
};
